import { track, logError } from '@tracking';
import getShop from '@core/reducers/shop/selectors/getShop';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getShopName from '@core/reducers/shop/selectors/getShopName';
import getCart from '@core/reducers/cart/selectors/getCart';
import getCartTotal from '@core/reducers/cart/selectors/getCartTotal';
import getFromOrderId from '@core/reducers/cart/selectors/getFromOrderId';

import getShopStatus from '@utils/tracking/getShopStatus';

import { getCartStatus, getProductQuantity, getCartUpdateInfo } from '../utils';

const EVENT_NAME = 'cart.updated';

const trackCartUpdated = (cartItems, prevCartItems, origin) => (
  _,
  getState,
) => {
  try {
    const { productsUpdated, cartUpdate } = getCartUpdateInfo(
      cartItems,
      prevCartItems,
    );

    if (!productsUpdated || !cartUpdate) return;

    const state = getState();
    const shop = getShop(state);
    const cart = getCart(state);

    const shopId = getShopId(state);
    const shopName = getShopName(state);
    const shopStatus = getShopStatus(shop);
    const cartValue = getCartTotal(state);
    const cartStatus = getCartStatus(cart);
    const cartQuantity = getProductQuantity(cartItems, productsUpdated);
    const repeatedOrder = Boolean(getFromOrderId(state));
    const originPage = origin || 'product_configuration';

    const payload = {
      shopId,
      shopName,
      shopStatus,
      repeatedOrder,
      cartValue,
      cartStatus,
      cartQuantity,
      productsUpdated,
      cartUpdate,
      origin: originPage,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackCartUpdated;
